import { Box, SxProps, Theme } from '@mui/material'

export interface FramedProps {
  children: React.ReactElement
  sx?: SxProps<Theme>
}

/**
 * Display a flag for a country,
 */
export const Framed = (props: FramedProps): React.ReactElement => {

  return (
    <Box sx={{
      m: 5,
      p: 5,
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
      textAlign: 'center',
      fontSize: 20,
      border: '1px solid rgba(255,255,255,0.2)',
      borderRadius: 4,
      ...props.sx
    }}>
      {props.children}
    </Box>
  )
}
